class ProductCountdown extends HTMLElement {
  constructor() {
    super();
    this.startTime = this.dataset.startTime;
    this.endTime = this.dataset.endTime;
    if (!!this.endTime) {
      this.init();
    }
  }

  init() {
    let startTime = this.startTime.toString();
    let endTime = this.endTime.toString();

    // 处理结束时间,获取时间戳
    let startTimeStr = startTime + " gmt+8";
    let endTimeString = endTime + " gmt+8";
    let newEndTime = new Date(endTimeString);
    let newEndTimeStr = newEndTime.getTime();

    let newStartTime = new Date(startTimeStr);

    // 获取当前时间的时间戳
    let currentDate = new Date();
    let currentDate1 = currentDate.getTime();

    // 时间差
    let timeDiff = newEndTimeStr - currentDate1;
    let timeDiff1 = parseInt(timeDiff / 1000);

    if (currentDate < newStartTime || currentDate > newEndTime) {
      document
        .querySelector(".product-block--countdown")
        .classList.add("hidden");
    } else {
      this.clock(timeDiff1);
    }
  }

  clock(times) {
    // 计算天
    var newDay = parseInt(times / 3600 / 24);

    // 页面加载时设置需要倒计时的秒数，计算小时
    var shi = parseInt(times / 3600);
    var newShi = parseInt((times % (3600 * 24)) / 3600);
    if (newShi < 10) {
      newShi = "0" + newShi;
    }

    // 计算分钟
    var fen = parseInt((times % 3600) / 60);
    if (fen < 10) {
      fen = "0" + fen;
    }
    var newFen = parseInt((times % 3600) / 60);
    if (newFen < 10) {
      newFen = "0" + newFen;
    }

    // 计算秒
    var miao = (times % 3600) % 60;
    if (miao < 10) {
      miao = "0" + miao;
    }
    var newMiao = (times % 3600) % 60;
    if (newMiao < 10) {
      newMiao = "0" + newMiao;
    }

    // 写入页面显示
    let domD = this.getElementsByClassName("count-days");
    let domH = this.getElementsByClassName("count-hours");
    let domM = this.getElementsByClassName("count-mins");
    let domS = this.getElementsByClassName("count-secs");
    for (let i = 0; i < domD.length; i++) {
      domD[i].innerHTML = newDay;
      domH[i].innerHTML = newShi;
      domM[i].innerHTML = newFen;
      domS[i].innerHTML = newMiao;
    }
    if (times > 0) {
      // 倒计时的秒数递减1
      times = times - 1;

      // 定时1秒，然后调用自身clock方法
      // 每次递减1，不停调用自身，实现循环，直到times=0
      var _this = this;
      setTimeout(function () {
        console.log(this);
        _this.clock(times);
      }, 1000);
    } else {
      alert("倒计时结束");
    }
  }
}

customElements.define("product-countdown", ProductCountdown);
